// PANTALLA 6 — Intentos Previos
// Documento Maestro v2.2, §4 (segunda pregunta) · pantalla propia desde el
// 24-09-2026.
//
// Es la pregunta que alimenta el bloque «la causa raíz» del plan final: sin
// ella, la Pantalla 9 no puede decirle al alumno por qué las veces anteriores
// no funcionaron. Por eso importa que se lea, y apilada bajo la autopercepción
// nacía fuera de pantalla.
import { useState } from 'react';
import OptionCards, { MicroReaction } from './OptionCards';
import { SCREEN4_ATTEMPTS_HEADLINE, PAST_ATTEMPTS } from './onboardingContent';
import { etiquetaDePaso } from './pasos';

export default function Screen4_5_Intentos({ attempts, onAnswer, onNext }) {
  const [selected, setSelected] = useState(attempts ?? null);

  const chosen = PAST_ATTEMPTS.find((a) => a.value === selected);

  const handleSelect = (v) => {
    setSelected(v);
    onAnswer({ past_attempts: v });
  };

  return (
    <div className="ob-screen">
      <p className="ob-eyebrow">{etiquetaDePaso(6)}</p>
      <h1 className="ob-headline">
        <span className="ob-headline-linea">{SCREEN4_ATTEMPTS_HEADLINE.linea}</span>
        <span className="ob-bloque">{SCREEN4_ATTEMPTS_HEADLINE.bloque}</span>
      </h1>

      <OptionCards options={PAST_ATTEMPTS} selected={selected} onSelect={handleSelect} />

      <MicroReaction text={chosen?.reaction} />

      {chosen && (
        <div className="ob-actions">
          <button type="button" className="ob-btn" onClick={onNext}>
            Continuar →
          </button>
        </div>
      )}
    </div>
  );
}
